import { render, staticRenderFns } from "./claim-records-modal.vue?vue&type=template&id=02dc3242"
import script from "./claim-records-modal.vue?vue&type=script&lang=js"
export * from "./claim-records-modal.vue?vue&type=script&lang=js"
import style0 from "./claim-records-modal.vue?vue&type=style&index=0&id=02dc3242&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports